import React, { useState, useEffect } from 'react';
import SelecionarCategoriaProduto from '../Utils/SelecionarCategoriaProduto';
import SelecionarMarca from '../Utils/SelecionarMarca';
import ImageCropper from '../Utils/ImageCropper';
import { Form, Button, Card, Alert, Col} from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useProvider, Toast } from '../../context/MenuProvider';

const SiteForm = () => {
    const navigate = useNavigate();
    const {
      crud,
      setLinks, 
      setBtns,
      auth,
      site: app,
      setTitle,
    } = useProvider();
    const [site, setSite] = useState(null);
    const [fileLogo, setFileLogo] = useState(null);
    const [fileFavicon, setFileFavicon] = useState(null);
    const [formErrors, setFormErrors] = useState({});
    const { patch, get, loading } = crud || {};
    const formData = new FormData();
    
    setTitle("Aplicativo")

    // Configuração inicial dos botões e links
    useEffect(() => {
        setLinks([]);
        setBtns([
          ...(site?.domain === window.location.hostname ? [{ icon: 'bi-check-lg', onClick: handleSubmit }]:[]),
        ]);

        return () => {
            setLinks([]);
            setBtns([]);
        };
    }, [setBtns, setLinks, site, fileLogo, fileFavicon]); // Removidas dependências desnecessárias


    useEffect(() => {
        carregarSite();
    }, [setSite]);
    

    const carregarSite = async () => {
        try {
            const response = await get(`/gvendas/site/?limit=1`);
            if (response && response.length) {
              setSite(response[0].results[0])
            }
        } catch (err) {
            validarErrosApi(err);
        }
    };

    const validarErrosApi = (err) => {
        const errorMessage = typeof err.response?.data === 'string' 
            ? 'Erro desconhecido ao salvar o produto.' 
            : err.response?.data?.detail;

        setFormErrors(prevErrors => ({
            ...prevErrors,
            apiError: errorMessage,
            categories: err.response?.data?.categories,
            name: err.response?.data?.name,
            descricao: err.response?.data?.descricao,
            nome_curto: err.response?.data?.nome_curto,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const errors = {};
        if (site?.name === '') errors.name = 'Por favor, informe o nome do app.';
        if (site?.nome_curto === '') errors.nome_curto = 'Por favor, informe o nome cirto do app.';

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

        setFormErrors({});
        
        formData.append('name', site?.name);
        formData.append('nome_curto', site?.nome_curto);
        formData.append('descricao', site?.descricao);
        formData.append('tema_cor', site?.tema_cor);
        formData.append('background_cor', site?.background_cor);
        formData.append('app_id', site?.app_id||site?.domain);
        formData.append('lang', site?.lang);
        formData.append('orientation', site?.orientation);
        formData.append('categories', toArray(site?.categories||"business"));
        //formData.append('screenshots', site?.screenshots);
        //formData.append('icons', site?.icons);
        
        if (fileLogo) formData.append('logo', fileLogo);
        if (fileFavicon) formData.append('favicon', fileFavicon);
        
        
        try {
            const response = await patch(formData, `/gvendas/site/${site?.id}/`, 'multipart/form-data');
            if (response) {
                Toast.fire({
                    icon: "success",
                    title: `App salvo com sucesso`
                });
            }
        } catch (err) {
            validarErrosApi(err);
        }
    };
    
    const toArray = (value) => {
      // Verifica se o valor já é um array
      if (Array.isArray(value)) {
        return JSON.stringify(value);
      }
    
      // Se for uma string com caracteres especiais, remove tudo que não for alfanumérico ou vírgula
      if (typeof value === 'string') {
        // Remove todos os caracteres especiais, mantendo apenas letras, números e vírgulas
        const sanitizedValue = value.replace(/[^a-zA-Z0-9,]/g, '');
        
        // Cria um array com os valores separados por vírgula
        const array = sanitizedValue.split(',').map(item => item.trim());
    
        return JSON.stringify(array);
      }
    
      // Caso o valor não seja nem array nem string, retorna uma lista com o próprio valor
      return JSON.stringify([value]);
    }
    
    if (site?.domain !== window.location.hostname){
      return (<>
        <div className="text-center fs-3">
          Acesse seu App principal para alterar essas configurações
        </div>
        <div className="text-center">
          Você não pode alterar pelo app {app?.nome_curto}
        </div>
      </>)
    }
    

    return (
        <div className="">
              <Card>
                <Card.Body>
                    <Form onSubmit={handleSubmit}>
                        {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}
                        <ImageCropper id="logo" label="Logo Inicial IOS" width={2048} height={2732} foto={site?.logo} setFoto={setFileLogo} />
                        <ImageCropper id="favicon" label="Ícone do App" width={512} height={512} foto={site?.favicon} setFoto={setFileFavicon} />
                        <Form.Group controlId="formNome" className="mt-3">
                            <Form.Label>Nome do App *</Form.Label>
                            <Form.Control
                                type="text"
                                value={site?.name} 
                                onChange={(e) =>
                                  setSite((prevSite) => ({
                                    ...prevSite,
                                    name: e.target.value
                                  }))
                                }
                            />
                            {formErrors.name && <Alert variant="danger">{formErrors.name}</Alert>}
                        </Form.Group>
                        <Form.Group controlId="formNome" className="mt-3">
                            <Form.Label>Nome curto do App *</Form.Label>
                            <Form.Control
                                type="text"
                                value={site?.nome_curto} 
                                onChange={(e) =>
                                  setSite((prevSite) => ({
                                    ...prevSite,
                                    nome_curto: e.target.value
                                  }))
                                }
                            />
                            {formErrors.nome_curto && <Alert variant="danger">{formErrors.nome_curto}</Alert>}
                        </Form.Group>
                        <Form.Group controlId="formCor" className="mt-3">
                            <Form.Label>Cor tema do App *</Form.Label>
                            <Form.Control
                                type="color"
                                value={site?.tema_cor || "#000000"} 
                                onChange={(e) =>
                                    setSite((prevSite) => ({
                                        ...prevSite,
                                        tema_cor: e.target.value
                                    }))
                                }
                            />
                            {formErrors.tema_cor && <Alert variant="danger">{formErrors.tema_cor}</Alert>}
                        </Form.Group>
                        <Form.Group controlId="formBGCor" className="mt-3">
                            <Form.Label>Cor de fundo do App *</Form.Label>
                            <Form.Control
                                type="color"
                                value={site?.background_cor || "#FFFFFF"} 
                                onChange={(e) =>
                                    setSite((prevSite) => ({
                                        ...prevSite,
                                        background_cor: e.target.value
                                    }))
                                }
                            />
                            {formErrors.background_cor && <Alert variant="danger">{formErrors.background_cor}</Alert>}
                        </Form.Group>
                        <Form.Group controlId="formAppId" className="mt-3">
                            <Form.Label>Id do do App</Form.Label>
                            <Form.Control
                                type="text"
                                value={site?.app_id || site?.domain} 
                                onChange={(e) =>
                                  setSite((prevSite) => ({
                                    ...prevSite,
                                    app_id: e.target.value
                                  }))
                                }
                            />
                            {formErrors.app_id && <Alert variant="danger">{formErrors.app_id}</Alert>}
                        </Form.Group>
                        <Form.Group controlId="formOrientacao" className="mt-3">
                            <Form.Label>Orientação</Form.Label>
                            <Form.Control
                                type="text"
                                value={site?.orientation} 
                                onChange={(e) =>
                                  setSite((prevSite) => ({
                                    ...prevSite,
                                    orientation: e.target.value
                                  }))
                                }
                            />
                            {formErrors.orientation && <Alert variant="danger">{formErrors.orientation}</Alert>}
                        </Form.Group>
                        <Form.Group controlId="formCategorias" className="mt-3">
                            <Form.Label>Categorias</Form.Label>
                            <Form.Control
                                type="text"
                                value={site?.categories ?? []} // Garante que seja uma string JSON
                                onChange={(e) => {
                                    setSite((prevSite) => ({
                                      ...prevSite,
                                      categories: e.target.value
                                  }));
                                }}
                                onBlur={(e) => {
                                    setSite((prevSite) => ({
                                      ...prevSite,
                                      categories: e.target.value
                                  }));
                                }}
                            />
                            {formErrors.categories && <Alert variant="danger">{formErrors.categories}</Alert>}
                        </Form.Group>
                        <Form.Group controlId="formDescricao" className="mt-3">
                            <Form.Label>Descrição</Form.Label>
                            <Form.Control 
                                as="textarea" 
                                value={site?.descricao} 
                                onChange={(e) => 
                                  setSite((prevSite) => ({
                                    ...prevSite,
                                    descricao: e.target.value
                                  }))
                                } 
                                rows={3} 
                            />
                        </Form.Group>

                        <Button variant="dark" type="submit" className="mt-4 w-100" disabled={loading}>
                            {loading ? 'Salvando...' : 'Salvar Alterações'}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};


export default SiteForm;